<template>
  <div>

    A maneuver is detected if the orbital change observed by comparing two consecutive mean orbits from two SP_ephemerides files is higher than 
    a threshold (<katex-element expression="thr_{sma} = 300 m" /> and <katex-element expression="thr_{inc} = 0.01 \degree" />).
    <br />
    <br />
    The detected maneuvers are an aggregation of the results of orbital changes over time. 
    Each consecutive file of SP_ephemerides where orbital changes were detected is added to a list creating the maneuver reports. 
    For each maneuver report, the validity of the results is calculated comparing it to the maneuver analysis validation results.
    <br />
    <br />
    Some additional information about the orbital changes of each maneuver can also be consulted. 
    It is also possible to observe the 3D representation of the orbits before and after the orbital changes. 
  </div>
</template>

<script>
export default {
  name: 'tooltipDetectedManeuvers'
}
</script>
